module.exports = __webpack_public_path__ + "img/bg-bucket.8a88f9a34d08614efe320c600b6ede5a.svg";